import authorize from './authorize';
import Store from '../store/store';

class AuthService {
  static counter = 0;

  constructor() {
    this.refreshingPromise = null;
    this.checker= true;
  }

  async refreshToken() {
    if (this.refreshingPromise) {
      return this.refreshingPromise;
    }
    this.refreshingPromise = new Promise((resolve, reject) => {
      (async () => {
        try {
          authorize.getTokenAcquireAsync();
          await AuthService.waitForTokenUpdate();
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          this.refreshingPromise = null;
           this.checker= false;
        }
      })();
    });

    return this.refreshingPromise;
  }

  static waitForTokenUpdate() {
    return new Promise((resolve, reject) => {
      const timeout = setTimeout(() => {
        // eslint-disable-next-line no-use-before-define
        unsubscribe();
        reject(new Error('Token update timed out'));
      }, 60000);

      const unsubscribe = Store.subscribe(() => {
        const authData = Store.getState().authenticationData?.userDetails;
        if (authData && authData.accessToken) {
          clearTimeout(timeout);
          unsubscribe();
          resolve();
        }
      });
    });
  }
}

export default new AuthService();
